<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M14.195 15.604a7 7 0 1 1 1.413-1.415l5.396 5.395-1.414 1.414-5.395-5.394ZM15 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z" clip-rule="evenodd"/>
</svg>
